<template>
  <div>
    <label v-if="label" :class="labelClass">{{ label }}</label>
    <div class="position-relative">
      <input :class="computedClassInput" :type="type" :disabled="disabled" :placeholder="placeholder"
        :required="required" :minlength="minlength" :maxlength="maxlength" :step="step" :value="value" :min="min"
        :max="max" v-mask="inputMask" @input="emitValue($event.target.value)"
        @keypress.enter="$emit('keypress', $event)" />
      <em v-if="icon && !error && !isValid" class="form-control-icon-normal" :class="computedEmClass"></em>
      <i v-if="isValid" :class="computedIconClass"></i>
      <span class="float-right font-weight-normal" v-if="showCharCount">
        <span v-if="maxlength > 0 && value">{{ counter }}</span>
        <span v-else>0</span>
        de {{ maxlength }}
      </span>
    </div>
    <error v-if="error" variant="no-border" :message="customErrorMsg" />
  </div>
</template>

<script>
import { mask } from 'ke-the-mask'
import Error from '@/components/common/Error'
export default {
  name: 'CustomInput',
  meta: {
    description: 'Componente para entrada de datos',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    Error,
  },
  directives: {
    mask,
  },
  props: {
    type: {
      type: String,
      default: 'text',
      meta: {
        description: 'Propiedad type personalizada',
        example: 'Texto requerido',
      },
    },
    label: {
      type: String,
      default: '',
      meta: {
        description: 'Control para mostrar texto ',
        example: 'Texto requerido',
      },
    },
    labelClass: {
      type: String,
      default: 'input-label',
      meta: {
        description: 'Clases para el label',
        example: 'Texto requerido',
      },
    },
    placeholder: {
      type: String,
      default: '',
      meta: {
        description: 'Texto de referencia en el input',
        example: 'Texto requerido',
      },
    },
    value: {
      type: [String, Number],
      default: '',
      meta: {
        description: 'Parámetro de entrada en el input',
        example: 'Texto requerido',
      },
    },
    required: {
      type: String,
      default: function () {
        return ''
      },
      meta: {
        description: 'Estado requerido',
        example: 'required',
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      meta: {
        description: 'Estado deshabilitado',
        example: 'disabled',
      },
    },
    minlength: {
      type: String,
      default: '',
      meta: {
        description: 'Logitud mínima requerida',
        example: 'Texto requerido',
      },
    },
    maxlength: {
      type: String,
      default: '',
      meta: {
        description: 'Logitud máxima requerida',
        example: 'Texto requerido',
      },
    },
    min: {
      type: Number,
      default: 0,
      meta: {
        description: 'Límite mínimo  en el input ',
        example: '14',
      },
    },
    max: {
      type: Number,
      default: 100,
      meta: {
        description: 'Límite máximo en el input ',
        example: '14',
      },
    },
    step: {
      type: Number,
      default: 1,
      meta: {
        description: 'Rango de intervalos ',
        example: '14',
      },
    },
    error: {
      type: String,
      default: '',
      meta: {
        description: 'Estado error',
        example: 'Texto requerido',
      },
    },
    dirty: {
      type: Boolean,
      default: function () {
        return false
      },
      meta: {
        description: 'Mostrar el checkmark si la validación es correcta',
        example: 'true',
      },
    },
    icon: {
      type: String,
      default: '',
      meta: {
        description: 'Propiedad para el icono ',
        example: 'fas fa-user-edit',
      },
    },
    customErrorMsg: {
      type: String,
      default: function () {
        return this.error
      },
      meta: {
        description: 'Personalización para mensajes de error',
        example: 'Texto requerido',
      },
    },
    maskType: {
      type: String,
      default: '',
      meta: {
        description: 'Máscaras del texto',
        example: 'Texto requerido',
      },
    },
    masked: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Condicional para Enmascarar texto',
        example: 'true',
      },
    },
    canModifyCss: {
      type: Boolean,
      default: true,
      meta: {
        description: 'Control modificación ',
        example: 'true',
      },
    },
    leftIcon: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Muestra el icono a la izquierda',
        example: 'true',
      },
    },
    showCharCount: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      maskTypes: [
        { id: 'Phone', mask: '(###)###-####' },
        { id: 'Number', mask: '####################' },
        { id: 'Date', mask: '##/##/####' },
        { id: 'Zipcode', mask: '#####' },
      ],
      inputMask: '',
      formControlClass: 'form-control',
    }
  },
  computed: {
    isValid() {
      return !this.error && this.dirty
    },
    computedClassInput() {
      let result = ''

      if (this.error) {
        result = ' was-Invalidated'
      } else if (this.isValid && this.canModifyCss) {
        result = ' was-validated'
      }

      if (this.leftIcon) {
        result = `${result} leftInput`
      }

      return this.formControlClass + result
    },
    computedEmClass() {
      let result = this.icon

      if (this.leftIcon) {
        result = `${result} left`
      }

      return result
    },
    computedIconClass() {
      let result = 'form-control-icon-normal far fa-lock-alt'

      if (this.canModifyCss) {
        if (this.isValid) {
          result = 'fa fa-checkmark sucess-icon'
        }
      }

      return result
    },
    counter() {
      return this.value.length
    },
  },
  mounted() {
    if (this.maskType != undefined) {
      let mask = this.maskTypes.find((x) => x.id == this.maskType)
      this.inputMask = mask != undefined ? mask.mask : ''
    }
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value)
    },
    emitValue(value) {
      if (this.maskType == undefined || this.masked) {
        this.$emit('input', value)
        return
      }

      let sentVal = this.formatMaskedText(value)

      this.$emit('input', sentVal)
    },
    formatMaskedText(value) {
      //conditionals to remove masks from text
      if (this.maskType == 'Phone' || this.maskType == 'Number') {
        return value.replace(/-|[()]/gi, '')
      }

      return value
    },
  },
}
</script>

<style scoped>
.leftInput {
  padding-left: 40px;
}

.sucess-icon {
  font-size: 19px;
  position: absolute;
  top: 9px;
  right: 7px;
  color: #3f5b60;
  margin-right: 0.2rem;
}

.sucess-icon:before {
  content: '\f058';
  color: #2db782;
}

span.invalid:not(input) {
  color: #e85c5c;
}

.form-control-icon-normal {
  position: absolute;
  top: 9px;
  right: 10px;
  color: #3f5b60;
  margin-right: 0.2rem;
}

.form-control-icon-normal.left {
  left: 15px;
  top: 11px;
  width: 20px;
}

.form-control-icon-invalid {
  color: #e85c5c;
  position: absolute;
  top: 9px;
  right: 10px;
  font-size: 19px;
}

.input-label {
  height: 19px;
  text-align: left;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
  line-height: 19px;
}

.form-control:disabled {
  background: #fff;
  cursor: not-allowed;
}

.modal-label {
  font-weight: 300;
  font-family: normal;
}

.custom-error i {
  float: left;
  margin-top: 15px;
  margin-right: 10px;
  color: #e85c5c;
}

.was-Invalidated {
  border: 1px solid #ff0018 !important;
}

.orange-icon {
  color: #ff7058;
}
</style>
